var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef } from "react";
import { StyledTableRow } from "./Table.style";
import useFocusVisibleWithin from "./useFocusVisibleWithin";
const TableRow = (props) => {
    const rowRef = useRef(null);
    const className = useFocusVisibleWithin(rowRef);
    const { rowRenderer } = props, rest = __rest(props, ["rowRenderer"]);
    const customStyledRow = rowRenderer ? rowRenderer(Object.assign(Object.assign({}, Object.assign(Object.assign({}, rest), { ref: rowRef })), { className })) : null;
    return customStyledRow ? customStyledRow : React.createElement(StyledTableRow, Object.assign({ ref: rowRef }, rest, { className: className }));
};
export default TableRow;
//# sourceMappingURL=TableRow.js.map